import React from 'react';
import classNames from 'classnames';
import { logExploreFilterSheetViewed } from '@alltrails/analytics/amplitudeFunctions';
import { Variant } from '@alltrails/shared/components/FormSelectorBase';
import { StringConstantsMixin } from 'application/javascripts/react_components/mixins/shared/string_constants_mixin';
import AlgoliaSearchBox from 'components/AlgoliaSearchBox';
import FilterBar from 'components/explore/FilterBar';
import MobileExploreMapSwitch from 'components/MobileExploreMapSwitch';
import MobileFiltersModal from 'components/explore/MobileFiltersModal';
import { FilterInput } from 'types/Search';
import { EXPLORE } from 'utils/constants/SearchAnalyticsConstants';
import legacyPerformSearch from 'utils/legacyPerformSearchUtil';
import * as styles from './styles/styles.module.scss';

class SearchFilterBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // Note: Had to add this 'enabledKey' here because the props.enabledFilters keys don't necessarily match the filter keys...
  getMappedFilters = () => {
    const pageStrings = StringConstantsMixin.strings.FILTERS;
    return {
      mappedFilters: [
        {
          display: pageStrings.SORT_LABEL,
          key: 'sort',
          enabledKey: 'sort',
          type: FilterInput.RADIO,
          config: this.props.filters.sort,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST
          }
        },
        {
          display: pageStrings.ACTIVITY_LABEL,
          key: 'activities',
          enabledKey: 'activity',
          type: FilterInput.RADIO,
          truncate: true,
          config: this.props.filters.activities,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST
          }
        },
        {
          display: pageStrings.DIFFICULTY,
          key: 'difficulty',
          enabledKey: 'difficulty',
          type: FilterInput.CHECKBOX,
          config: this.props.filters.difficulty,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST
          }
        },
        {
          display: pageStrings.LENGTH,
          key: 'lengths',
          enabledKey: 'length',
          type: FilterInput.SLIDER,
          config: this.props.filters.lengths
        },
        {
          display: pageStrings.SUITABILITY,
          key: 'access',
          enabledKey: 'access',
          type: FilterInput.CHECKBOX,
          config: this.props.filters.access,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST
          }
        },
        {
          display: pageStrings.FEATURES_LABEL,
          key: 'features',
          enabledKey: 'feature',
          type: FilterInput.CHECKBOX,
          nested: true,
          truncate: true,
          config: this.props.filters.features,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        },
        {
          display: pageStrings.ELEV_GAIN,
          key: 'elevation_gain',
          enabledKey: 'elevation_gain',
          type: FilterInput.SLIDER,
          nested: true,
          config: this.props.filters.elevation_gain
        },
        {
          display: pageStrings.ROUTE_TYPE,
          key: 'route_type',
          enabledKey: 'route_type',
          type: FilterInput.CHECKBOX,
          nested: true,
          config: this.props.filters.route_type,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST
          }
        },
        {
          display: pageStrings.RATING,
          key: 'minRating',
          enabledKey: 'rating',
          type: FilterInput.STAR_RATING,
          nested: true,
          config: this.props.filters.minRating
        },
        {
          display: pageStrings.TRAIL_TRAFFIC,
          key: 'visitor_usage',
          enabledKey: 'visitor_usage',
          type: FilterInput.CHECKBOX,
          nested: true,
          config: this.props.filters.visitor_usage,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        },
        {
          display: pageStrings.TRAIL_COMPLETION,
          key: 'completed',
          enabledKey: 'completed',
          type: FilterInput.CHECKBOX,
          nested: true,
          config: this.props.filters.completed,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        },
        {
          display: 'Closed',
          key: 'closed_status',
          enabledKey: 'closed_status',
          type: FilterInput.CHECKBOX,
          admin: true,
          config: this.props.filters.closed_status,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        },
        {
          display: 'Parks',
          key: 'areas',
          enabledKey: 'area',
          type: FilterInput.CHECKBOX,
          admin: true,
          truncate: true,
          config: this.props.filters.areas,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        },
        {
          display: 'City',
          key: 'cities',
          enabledKey: 'city',
          type: FilterInput.CHECKBOX,
          admin: true,
          truncate: true,
          config: this.props.filters.cities,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        },
        {
          display: 'State',
          key: 'states',
          enabledKey: 'state',
          type: FilterInput.CHECKBOX,
          admin: true,
          truncate: true,
          config: this.props.filters.states,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        },
        {
          display: 'Country',
          key: 'countries',
          enabledKey: 'country',
          type: FilterInput.CHECKBOX,
          admin: true,
          truncate: true,
          config: this.props.filters.countries,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        },
        {
          display: 'Linked',
          key: 'linked',
          enabledKey: 'linked',
          type: FilterInput.CHECKBOX,
          admin: true,
          truncate: true,
          config: this.props.filters.linked,
          extraProps: {
            variant: Variant.INLINE_INPUT_FIRST,
            useColumns: true
          }
        }
      ]
    };
  };

  getMappedProps = () => {
    return { ...this.getMappedFilters(), ...this.props };
  };

  openFiltersModal = () => {
    logExploreFilterSheetViewed({ search_origin: EXPLORE });
    this.setState({
      filtersModalOpen: true
    });
    $('body').css('overflow', 'hidden');
    $('.hide-for-fullscreen-modal').css('display', 'none');
  };

  closeFiltersModal = () => {
    this.setState({
      filtersModalOpen: false
    });
    $('body').css('overflow', 'unset');
    $('.hide-for-fullscreen-modal').css('display', '');
  };

  renderFiltersModal = () => {
    if (!this.state.filtersModalOpen) {
      return null;
    }

    return (
      <MobileFiltersModal
        clearAllFilters={this.props.clearAllFilters}
        context={this.props.context}
        enabledFilters={this.props.enabledFilters}
        filterConfigs={this.props.filters}
        handleClose={this.closeFiltersModal}
        handleFilterRadioToggle={this.props.handleFilterRadioToggle}
        handleFilterSet={this.props.handleFilterSet}
        handleFilterSlider={this.props.handleFilterSlider}
        handleFilterToggle={this.props.handleFilterToggle}
        resultsCount={this.props.resultsCount}
      />
    );
  };

  renderButtons = () => {
    return (
      <div className={styles.buttons}>
        <button className={styles.filtersButton} onClick={this.openFiltersModal} />
        <MobileExploreMapSwitch showMapMobile={this.props.filters.mobileMap} />
      </div>
    );
  };

  render() {
    const searchResultsCountFunction = (changes) =>
      new Promise(resolve => {
        legacyPerformSearch({
          algoliaIndex: this.props.algoliaIndex,
          atMaps: this.props.atMaps,
          context: this.props.page,
          filters: {
            ...this.props.filters,
            ...changes
          },
          // For /explore pages and typical trail searches this handler is called.
          handleSearchResults: results => resolve(results?.hits?.length ?? 0),
          // If viewing the current user's custom maps this handler is called.
          // Note this isn't actually a search. This is a filter on atMaps.
          handleUserResults: results => resolve(results?.length ?? 0),
          initialUserSlug: this.props.initialUserSlug,
          isMobileWidth: this.props.isMobileWidth,
          listMethods: this.props.listMethods,
          page: this.props.page,
        });
      });

    return (
      <div className={styles.wrapper}>
        <div className={classNames(styles.container, { 'hide-for-fullscreen-modal': this.props.isMobileWidth } )}>
          <AlgoliaSearchBox
            algoliaIndexId={this.props.context.primaryAlgoliaIndexId}
            className={styles.search}
            handleTrailSelect={this.props.handleTrailSelected}
            handleAreaSelect={this.props.handleObjectSelected}
            handleLocationSelect={this.props.handleObjectSelected}
            handleQueryStringSubmit={queryString => this.props.handleQueryTermSet(queryString.trim())}
            allowStringSearch={this.props.allowStringSearch}
            liveStringSearch={this.props.liveStringSearch}
            onSearchPage
            numResults={this.props.isMobileWidth ? 8 : 10}
            placeholderText={this.props.placeholderText}
            currentUser={this.props.context.currentUser}
            mobileBrowser={this.props.context.mobileBrowser}
            languageRegionCode={this.props.context.languageRegionCode}
            typeSubset={this.props.typeSubsets}
            defaultLatLng={this.props.defaultLatLng}
            listTrailIds={this.props.filters.trailIds}
            useNewSearchExperience
            page={EXPLORE}
          />
          <FilterBar searchResultsCountFunction={searchResultsCountFunction} {...this.getMappedProps()} variant={EXPLORE} className={styles.filterBar} />
          {this.renderButtons()}
        </div>
        {this.renderFiltersModal()}
      </div>
    );
  }
}

export default SearchFilterBar;
